import { axiosInstance as axios } from "@/utils/wd_axios.js";
import {  userKeys, wdConfigData } from "@/service/wd_app_config.js";


// 普通GPT消息 /Talks/{{TalkId}}/Messages/Create
// export const api_chat_is_task_old = (params, talkId) => {
//   let requestpParams = {
//     Text: "你是一个人工智能助手，可以根据用户输入的内容来判断用户的意图符合以下4个场景中的哪一个场景，请直接返回最接近那个场景的名字，不要回答场景名字之外的任何内容；以下场景：【1.做个完整Slides；2. 做一页Slide；3. 调整单页Slides；4. 普通描述】;\n 用户输入内容：【" + params.text + "】"
//   }
//   var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
//   var url = `${wdConfigData.baseURLApi}/Talks/${talkId}/Messages/Create`;
//   return axios.post(url, requestpParams, {
//     headers: {
//       AccessToken: accessToken,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//   });
// };

// 上传文件，文件生成ppt：/App/Users/{{UserId}}/FileManagement/UploadFile
export const api_upload_file = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject))
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken)
  var url = `${wdConfigData.baseURLApi}/App/Users/${user.Id}/FileManagement/UploadFile`
  return axios.post(url, params, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
// 生成完整Slides /Talks/{{TalkId}}/Messages/GenerateWholeSemanticContent
export const api_generate_whole_semantic_ppt = (params, talkId) => {
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Talks/${talkId}/Messages/GenerateWholeSemanticContent`;
  return axios.post(url, params, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 普通GPT消息，用来判断用户意图 /Talks/{{TalkId}}/Messages/BeforeCreate
export const api_chat_is_task = (messageContent, talkId) => {
  let requestpParams = {
    MsgType:'0',
    UserContent: messageContent
  }
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Talks/${talkId}/Messages/BeforeCreate`;
  return axios.post(url, requestpParams, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取GPT List
// /App/{userId}/GPT/Config/GetList
export const wd_getGptList = () => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/App/${user.Id}/GPT/Config/GetList`;
  return axios.get(url, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取Gpt Talk
// Talks/{userId}/{gptUserId}/0/Query
export const wd_queryGptTalk = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Talks/${user.Id}/${params.gptUserId}/0/Query`;
  return axios.get(url, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取Gpt Talk的消息列表
// Users/{当前UserId}/Talks/{TalkId}/Messages?start=0&count=3
export const wd_getGptTalkMessageList = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Users/${user.Id}/Talks/${params.talkId}/Messages?start=${params.start}&count=${params.count}`;
  return axios.get(url, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 咨询Gpt
// post
// Talks/{talkId}/Messages/Create
export const wd_askGpt = (params) => {
  var requestBody = {
    Text: params.promptText,
  };
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Talks/${params.talkId}/Messages/Create`;
  return axios.post(url, requestBody, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 取消gpt排队
// post
// Corporations/{corpId}/Users/{userId}/Talks/{talkId}/Queues/{queueId}/2
export const wd_cancelGptQueue = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var corporationId = JSON.parse(
    localStorage.getItem(userKeys.key_corporationId)
  );
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Corporations/${corporationId}/Users/${user.Id}/Talks/${params.talkId}/Queues/${params.queueId}/2`;
  return axios.post(url, "", {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取预置提问列表
// get
// /App/{userId}/GPT/Config/{configId}/PreProblem/GetList
export const wd_getGptPrePromptList = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/App/${user.Id}/GPT/Config/${params.configId}/PreProblem/GetList`;
  return axios.get(url, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 给Gpt答案打分，有用80，没用40
// post
// Talks/{talkId}/Answers/{messageId}/Score/80
export const wd_scoreAnswer = (params) => {
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Talks/${params.talkId}/Answers/${params.messageId}/Score/${params.score}`;
  return axios.post(url, "", {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 获取GPT问答列表
// get
// Users/{GPT的UserId}/GPTAnswers?start=0&count=3
export const wd_getGptQandAList = (params) => {
  var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  var url = `${wdConfigData.baseURLApi}/Users/${user.Id}/GPTAnswers?start=${params.start}&count=${params.count}&configId=${params.gptConfigId}`;
  return axios.get(url, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};